<template>
  <button :disabled="disabled" :class="classObject" v-on:click="$emit('click')" @click="redirect()">
    <slot></slot>
  </button>
</template>
<script>
export default {
  name: 'TButton',
  props: {
    classCustom: String,
    color: {
      type: String,
      default: ''
    },
    size: {
      default: 'md'
    },
    disabled: {
      default: false
    },
    to: {
      type: String,
      default: ''
    }
  },
  computed: {
    classObject () {
      return [['tbutton', this.buttonColor], [this.buttonSize]]
    },
    buttonColor () {
      const color = this.color
      return color === '' ? color : `tbutton-${color}`
    },
    buttonSize () {
      const size = this.size
      return size === '' ? size : `tbutton-${size}`
    }
  },
  methods: {
    redirect () {
      if (this.to !== '') this.$router.push({ name: this.to })
    }
  }
}
</script>

<style scoped>
.tbutton {
  display: inline-block;
  font-weight: 600;
  color: #fff;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  font-size: 1rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  background-color: #ff6501;
  border-radius: 8px;
}
button.tbutton-xs {
  padding: 0.25rem 0.5rem ;
  font-size: 0.775rem;
  line-height: 1;
  border-radius: 8px;
}
button.tbutton-sm {
  padding: 0.25rem 0.5rem ;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 8px;
}
button.tbutton-md {
  padding: 0.375rem 0.75rem;
  font-size: 1rem !important;
  line-height: 1.5;
  border-radius: 8px;
}
button.tbutton-lg {
  padding: 0.75rem 2rem ;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 8px;
}
.tbutton:hover {
  background-color: #fb761e;
  border-color: #ff6501;
}
.tbutton:active {
  background-color: #f87d2b;
  border-color: #ff6501;
}
.tbutton:focus {
  box-shadow: 0 0 0 0.2rem rgba(241, 130, 39, 0.993);
}
@media screen and (min-width: 768px) {
  .tbutton {
    font-size: 1em;
    cursor: pointer;
    padding: 0.375rem 0.75rem;
  }
}
.tbutton-0f62ab {
  background-color: #0f62ab;
}
.tbutton-0f62ab:hover {
  background-color: #0069d9;
  border-color: #0062cc;
}
.tbutton-0f62ab:active {
  background-color: #016de0;
  border-color: #0062cc;
}
.tbutton-0f62ab:focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5);
}
.tbutton-0f62ab:disabled {
    background-color: #0069d9;;
    border-color: #0069d9;;
}
.tbutton:disabled {
    opacity: .65;
    cursor: auto;
}
.tbutton-grey {
  background-color: rgb(240, 240, 240, 0.3);
  border: 1px solid #0873b4;
  color: #0873b4;
}
.tbutton-grey:hover {
  background-color: #0f62ab;
  border-color: #0062cc;
  color: #fff;
}
.tbutton-grey:active {
  background-color: #016de0;
  border-color: #0062cc;
  color: #fff;
}
.tbutton-grey:focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5);
  color: #fff;
}
.tbutton-success {
  background-color: #28a745;
  border: 1px solid #28a745;
  color: #fff;
}
.tbutton-success:hover {
  color: #fff;
  background-color: #218838;
  border-color: #1e7e34;
}
.tbutton-success:active {
  color: #fff;
  background-color: #1e7e34;
  border-color: #1c7430;
}
.tbutton-success:focus {
  box-shadow: 0 0 0 0.2rem rgba(72, 180, 97, 0.5);
  color: #fff;
}
.tbutton-danger {
  color: #fff;
  background-color: #dc3545;
  border-color: #dc3545;
}
.tbutton-danger:hover {
  color: #fff;
  background-color: #c82333;
  border-color: #bd2130;
}
.tbutton-danger:active {
  color: #fff;
  background-color: #bd2130;
  border-color: #b21f2d;
}
.tbutton-danger:focus {
  box-shadow: 0 0 0 0.2rem rgba(225, 83, 97, 0.5);
  color: #fff;
}
</style>
